module.exports = __webpack_public_path__ + "img/sattelite-gray.3eb5e0fc.svg";